import { omit } from 'ramda';
import ActionTypes from '../action.types';
import moment from 'moment';

export default function dashboard(state = initialState(), action) {
  switch (action.type) {
    case ActionTypes.CUSTOMERS_LIST_REQUESTED:
      return {
        ...state,
        isCustomerListLoading: true,
      };
    case ActionTypes.CUSTOMERS_LIST_DONE:
      return {
        ...state,
        isCustomerListLoading: false,
        ...omit(['type', 'meta'], action),
        meta: {
          ...action.meta,
          timeRange: parseTimeRange(action.meta.timeRange),
        },
      };
    case ActionTypes.ERROR:
      return {
        ...state,
        isCustomerListLoading: false,
        error: action.error
      };
    default:
      return state;
  }
}

function parseTimeRange(timeRange) {
  return { from: moment(timeRange.from), to: moment(timeRange.to) };
}

function initialState() {
  return {
    isCustomerListLoading: false,
    payload: { items: [] },
    meta: {
      user: {},
      timeRange: { from: moment().subtract(1, 'year'), to: moment() },
    },
  };
}



// WEBPACK FOOTER //
// ./src/Dashboard/reducer.js